import { getRailsClient } from "../../client";

export const getAdminSettings = async () => {
  try {
    const API = "/api/internal_api/v1/admin/settings";
    const { data } = await getRailsClient().get(API);
    return data.settings;
  } catch (error) {
    console.error("Error fetching admin settings:", error);
    throw error;
  }
};
